export default "__VITE_ASSET__8e8f5a7f__"